// Firebase v10 modular SDK initialization for Presto CRM.
// Region: asia-southeast1 (Cloud Functions). Emulator-first for local dev.
//
// Config is read from Vite env vars (VITE_FB_*). For local emulator work the
// placeholder values in .env.example are sufficient; the real project's values
// get dropped in when we promote to a live Firebase project (see SESSION_LOG).
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const FUNCTIONS_REGION = 'asia-southeast1';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY ?? 'demo-api-key',
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN ?? 'presto-crm.firebaseapp.com',
  projectId: import.meta.env.VITE_FB_PROJECT_ID ?? 'presto-crm',
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET ?? 'presto-crm.appspot.com',
  messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID ?? '0000000000',
  appId: import.meta.env.VITE_FB_APP_ID ?? '1:0000000000:web:0000000000000000000000',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);

// Wire up local emulators when VITE_USE_EMULATORS=true (set in .env for dev).
const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';
if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
